<script setup>
import GenericProgressBar from './GenericProgressBar.vue';
import { httpRequestWithProgress } from '@/plugins/utils/httpRequest'
import { watch, ref } from 'vue'
import { usePortAllData } from '@/stores/portAllData';
import { storeToRefs } from 'pinia';
import { DateTime } from 'luxon';

const store = usePortAllData()
const { getIsMobile } = storeToRefs(store)

const props = defineProps({
  modalActive: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'image'
  },
  request: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['closeModal'])

const progressBar = ref()
const isLoading = ref(false)
const response = ref(null)
const imgResult = ref(null)
const textResult = ref(null)
const urlResult = ref(null)

const closeModal = (e) => {
  e.stopPropagation()
  emit('closeModal')
}

const clickOnModal = (e) => {
  e.stopPropagation()
}

const onProgress = async (e) => {
  isLoading.value = true
  progressBar.value.setProgress(e)
  if (e === 1) {
    isLoading.value = false
    if (response.value && response.value.ok) {
      switch (props.type) {
        case 'image': {
          const result = await response.value.blob()
          imgResult.value = URL.createObjectURL(result)  
          break
        }
        case 'text': {
          const result = await response.value.blob()
          const reader = new FileReader()
          reader.addEventListener('loadend', (e) => {
            textResult.value = e.target.result
          })
          reader.readAsText(result)
          break
        }
        case 'pdf': {
          const result = await response.value.blob()
          urlResult.value = URL.createObjectURL(result)
          emit('closeModal')
          if (getIsMobile.value) downloadPdf()
          else window.open(urlResult.value, '_blank')
          break
        }
        default: {
          const result = await response.value.blob()
          urlResult.value = URL.createObjectURL(result)
          emit('closeModal')
          if (getIsMobile.value) downloadPdf()
          else window.open(urlResult.value, '_blank')
        }
      }
    }
  }
}

const downloadPdf = () => {
  if (urlResult.value) {
    const dateNow = DateTime.now()
    const filename = `Pictorial_representation_${dateNow.toFormat('yyyy-MM-dd_HH-mm')}.pdf`
    const a = document.createElement('a')
    a.href = urlResult.value
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  }
}

watch(() => props.modalActive, async (nv) => {
  if (nv) {
    response.value = await httpRequestWithProgress(props.request, { method: 'GET' }, false, onProgress)
  } else {
    if (imgResult.value) {
      URL.revokeObjectURL(imgResult.value)
      imgResult.value = null
    }
    if (urlResult.value) {
      URL.revokeObjectURL(urlResult.value)
      urlResult.value = null
    }
    isLoading.value = false
    response.value = null
  }
})
</script>

<template>
  <Teleport to="body">
    <transition name="modal-animation">
      <div v-show="modalActive" class="modal" @click="clickOnModal">
        <transition name="modal-animation-inner">
          <div v-show="modalActive" class="modal-inner">
            <div class="header">
              <i class="icon-cancel" @click="closeModal" />
            </div>
            <div class="content">
              <generic-progress-bar v-show="isLoading" ref="progressBar" />
              <img v-if="imgResult" :src="imgResult">
              <pre v-if="textResult">{{ textResult }}</pre>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </Teleport>
</template>